import { AttributeType, SugarAttributeInfo } from "../../Suggester/SugarElementInfo";

export const pathAttribute: SugarAttributeInfo = {
    name: "path",
    valueTypes: [AttributeType.Path],
};
